import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { TermsOfServiceSEO } from './SEO';

export const TermsOfService = () => {
  return (
    <div className="min-h-screen">
      <TermsOfServiceSEO />
      <Header />
      <main className="py-16 bg-slate-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <article className="bg-white rounded-2xl shadow-lg p-8 lg:p-12">
            <h1 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-8">
              Terminos de Servicio
            </h1>

            <p className="text-slate-600 mb-8">
              Ultima actualizacion: 5 de enero de 2026
            </p>

            <div className="prose prose-slate max-w-none">
              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                  1. Aceptacion de los Terminos
                </h2>
                <p className="text-slate-600 mb-4">
                  Al acceder y utilizar los servicios de Neurolytics, aceptas estos terminos y condiciones en su totalidad.
                  Si no estas de acuerdo con alguno de estos terminos, no debes utilizar nuestros servicios.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                  2. Descripcion de los Servicios
                </h2>
                <p className="text-slate-600 mb-4">
                  Neurolytics proporciona servicios de tecnologia e inteligencia artificial que incluyen:
                </p>
                <ul className="list-disc pl-6 text-slate-600 space-y-2">
                  <li>Desarrollo de soluciones de inteligencia artificial</li>
                  <li>Analisis de datos y business intelligence</li>
                  <li>Automatizacion de procesos empresariales</li>
                  <li>Desarrollo de software a medida</li>
                  <li>Consultoria tecnologica</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                  3. Proceso de Contratacion
                </h2>
                <p className="text-slate-600 mb-4">
                  El proceso de contratacion de nuestros servicios incluye:
                </p>
                <ol className="list-decimal pl-6 text-slate-600 space-y-2">
                  <li>Consulta inicial gratuita para entender tus necesidades</li>
                  <li>Presentacion de propuesta personalizada con alcance y presupuesto</li>
                  <li>Firma de contrato de servicios</li>
                  <li>Desarrollo e implementacion de la solucion</li>
                  <li>Entrega y capacitacion</li>
                  <li>Soporte post-implementacion</li>
                </ol>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                  4. Pagos y Facturacion
                </h2>
                <p className="text-slate-600 mb-4">
                  Condiciones de pago aplicables a todos los servicios de Neurolytics:
                </p>
                <ul className="list-disc pl-6 text-slate-600 space-y-2">
                  <li>
                    <strong>Forma de pago:</strong> Todos los pagos se realizan mediante <strong>boleta de honorarios</strong> emitida
                    por Neurolytics, conforme a la normativa tributaria chilena vigente.
                  </li>
                  <li>
                    <strong>Retencion de impuestos:</strong> Los presupuestos y cotizaciones presentados corresponden al monto neto
                    de los servicios y <strong>no incluyen el valor de la retencion del 15,25%</strong> establecida para el año 2026.
                    Este porcentaje debera ser retenido y declarado por el cliente pagador segun la legislacion vigente.
                  </li>
                  <li>
                    <strong>Modalidades de pago:</strong> Se aceptan transferencias bancarias y otros medios de pago acordados
                    previamente en el contrato de servicios.
                  </li>
                  <li>
                    <strong>Calendario de pagos:</strong> Los pagos se estructuran segun el alcance del proyecto, pudiendo incluir
                    anticipos, pagos por hitos o pago completo al finalizar, segun se acuerde en cada contrato.
                  </li>
                </ul>
                <p className="text-slate-600 mt-4">
                  <em>Nota: Las tasas de retencion pueden variar segun actualizaciones de la normativa tributaria.
                  Se recomienda verificar las tasas vigentes al momento de efectuar el pago.</em>
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                  5. Obligaciones del Cliente
                </h2>
                <p className="text-slate-600 mb-4">
                  Como cliente, te comprometes a:
                </p>
                <ul className="list-disc pl-6 text-slate-600 space-y-2">
                  <li>Proporcionar informacion veraz y actualizada</li>
                  <li>Colaborar en el proceso de desarrollo y testing</li>
                  <li>Cumplir con los plazos de revision y aprobacion acordados</li>
                  <li>Realizar los pagos segun los terminos acordados</li>
                  <li>No utilizar nuestros servicios para fines ilegales</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                  6. Propiedad Intelectual
                </h2>
                <p className="text-slate-600 mb-4">
                  Una vez completado el pago total del proyecto:
                </p>
                <ul className="list-disc pl-6 text-slate-600 space-y-2">
                  <li>El cliente obtiene los derechos de uso del software desarrollado</li>
                  <li>El codigo fuente sera entregado segun lo acordado en el contrato</li>
                  <li>Neurolytics retiene los derechos sobre metodologias y herramientas propias</li>
                  <li>Los datos del cliente permanecen siendo propiedad exclusiva del cliente</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                  7. Garantias
                </h2>
                <p className="text-slate-600 mb-4">
                  Neurolytics ofrece:
                </p>
                <ul className="list-disc pl-6 text-slate-600 space-y-2">
                  <li>Garantia de satisfaccion de 90 dias</li>
                  <li>Correccion de errores detectados durante el periodo de garantia sin costo adicional</li>
                  <li>Soporte tecnico durante el periodo de garantia</li>
                </ul>
                <p className="text-slate-600 mt-4">
                  La garantia no cubre modificaciones realizadas por terceros o uso indebido del software.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                  8. Limitacion de Responsabilidad
                </h2>
                <p className="text-slate-600 mb-4">
                  Neurolytics no sera responsable por:
                </p>
                <ul className="list-disc pl-6 text-slate-600 space-y-2">
                  <li>Danos indirectos, incidentales o consecuentes</li>
                  <li>Perdida de datos debido a factores fuera de nuestro control</li>
                  <li>Interrupciones de servicio de terceros</li>
                  <li>Uso inadecuado de las soluciones entregadas</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                  9. Confidencialidad
                </h2>
                <p className="text-slate-600 mb-4">
                  Nos comprometemos a mantener la confidencialidad de toda la informacion proporcionada por el cliente,
                  incluyendo datos comerciales, tecnicos y estrategicos. Esta obligacion permanece vigente incluso
                  despues de finalizada la relacion comercial.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                  10. Terminacion
                </h2>
                <p className="text-slate-600 mb-4">
                  Cualquiera de las partes puede terminar el contrato de servicios mediante notificacion escrita
                  con 30 dias de anticipacion. En caso de terminacion anticipada, el cliente debera pagar por
                  los servicios ya prestados.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                  11. Ley Aplicable
                </h2>
                <p className="text-slate-600 mb-4">
                  Estos terminos se rigen por las leyes de la Republica de Chile. Cualquier disputa sera resuelta
                  en los tribunales competentes de la region de Los Lagos, Chile.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                  12. Contacto
                </h2>
                <p className="text-slate-600 mb-4">
                  Para consultas sobre estos terminos de servicio:
                </p>
                <ul className="list-none text-slate-600 space-y-2">
                  <li><strong>Email:</strong> hola@neurolytics.cl</li>
                  <li><strong>WhatsApp:</strong> +56 9 6294 2789</li>
                  <li><strong>Ubicacion:</strong> Los Lagos, Chile</li>
                </ul>
              </section>
            </div>

            <div className="mt-12 pt-8 border-t border-slate-200">
              <a
                href="/"
                className="text-emerald-600 hover:text-emerald-700 font-medium transition-colors duration-200"
              >
                ← Volver al inicio
              </a>
            </div>
          </article>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfService;
